import {Competition} from "@brg/api";
import {getDaysToFinish} from "./getDaysToFinish";
import {STATUSES} from "../const";
import moment from "moment";

export enum COMPETITION_STATUSES {
    default,
    deadline_soon,
    apply_finish,
    full_finish
}

const DEADLINE_SOON_DAYS = 10;

export const getCompetitionStatus = (competition?: Competition<'Local'>) => {
    if (!competition) return COMPETITION_STATUSES.default;

    const endDate = moment.utc(competition?.endDate).add(3, 'hours').toDate();
    const currentDate = moment.utc().add(3, 'hours').toDate();

    if (competition?.status === STATUSES['Completed']) return COMPETITION_STATUSES.full_finish;
    if (endDate.getTime() < currentDate.getTime()) return COMPETITION_STATUSES.apply_finish;
    if (getDaysToFinish(endDate) <= DEADLINE_SOON_DAYS) return COMPETITION_STATUSES.deadline_soon;

    return COMPETITION_STATUSES.default;
};import {Competition} from "@brg/api";
import {getDaysToFinish} from "./getDaysToFinish";
import {STATUSES} from "../const";
import moment from "moment";

export enum COMPETITION_STATUSES {
    default,
    deadline_soon,
    apply_finish,
    full_finish
}

const DEADLINE_SOON_DAYS = 10;

export const getCompetitionStatus = (competition?: Competition<'Local'>) => {
    if (!competition) return COMPETITION_STATUSES.default;

    const endDate = moment.utc(competition?.endDate).add(3, 'hours').toDate();
    const currentDate = moment.utc().add(3, 'hours').toDate();

    if (competition?.status === STATUSES['Completed']) return COMPETITION_STATUSES.full_finish;
    if (endDate.getTime() < currentDate.getTime()) return COMPETITION_STATUSES.apply_finish;
    if (getDaysToFinish(endDate) <= DEADLINE_SOON_DAYS) return COMPETITION_STATUSES.deadline_soon;

    return COMPETITION_STATUSES.default;
};